"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemFromJSON = MenuItemFromJSON;
exports.MenuItemFromJSONTyped = MenuItemFromJSONTyped;
exports.MenuItemToJSON = MenuItemToJSON;
exports.MenuItemToJSONTyped = MenuItemToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function MenuItemFromJSON(json) {
    return MenuItemFromJSONTyped(json, false);
}
function MenuItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'imageUrls': !(0, runtime_1.exists)(json, 'imageUrls') ? undefined : (0, _1.ImageUrlsFromJSON)(json['imageUrls']),
        'label': !(0, runtime_1.exists)(json, 'label') ? undefined : json['label'],
        'targetUrl': !(0, runtime_1.exists)(json, 'targetUrl') ? undefined : json['targetUrl'],
        'target': !(0, runtime_1.exists)(json, 'target') ? undefined : json['target'],
        'menuItems': !(0, runtime_1.exists)(json, 'menuItems') ? undefined : (json['menuItems'].map(MenuItemFromJSON)),
    };
}
function MenuItemToJSON(value) {
    return MenuItemToJSONTyped(value, false);
}
function MenuItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'imageUrls': (0, _1.ImageUrlsToJSON)(value.imageUrls),
        'label': value.label,
        'targetUrl': value.targetUrl,
        'target': value.target,
        'menuItems': value.menuItems === undefined ? undefined : (value.menuItems.map(MenuItemToJSON)),
    };
}
